import React, { createContext, useContext } from 'react';

import dayjs, { Dayjs } from 'dayjs';

import { SNAPSHOT_SELECTOR_SELECTION } from './constants';
import { SnapshotDataType } from '../../../types/snapshot';
import { SNAPSHOT_MODAL_STEP } from '../constants';

type SnapshotEditorContentType = {
  communityId: number;
  step: number;
  selection: number;
  date: Dayjs;
  selectedSnapshot: SnapshotDataType | undefined;
  selectedHistoricalSnapshot: SnapshotDataType | undefined;
  setStep: (value: number) => void;
  setSelection: (value: number) => void;
  setDate: (value: Dayjs) => void;
  setSelectedSnapshot: (value: SnapshotDataType | undefined) => void;
  setSelectedHistoricalSnapshot: (value: SnapshotDataType | undefined) => void;
};

export const SnapshotEditorContext = createContext<SnapshotEditorContentType>({
  communityId: -1,
  step: SNAPSHOT_MODAL_STEP.DEFAULT,
  selection: SNAPSHOT_SELECTOR_SELECTION.ENTER_NEW_DATA,
  date: dayjs(),
  selectedSnapshot: undefined,
  selectedHistoricalSnapshot: undefined,
  setStep: () => {
    // Do nothing
  },
  setSelection: () => {
    // Does Nothing
  },
  setDate: () => {
    // Does Nothing
  },
  setSelectedSnapshot: () => {
    // Does Nothing
  },
  setSelectedHistoricalSnapshot: () => {
    // Does Nothing
  },
});

export const useSnapshotEditorContext = () => useContext(SnapshotEditorContext);
